'use strict';

module.exports = strikethrough;

function strikethrough(node) {
  return '~~' + this.all(node).join('') + '~~';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/delete.js
// module id = 287
// module chunks = 147254134005266 182246549230831 215303740077764